import { AuditApiRemoteService } from '../../Services/api/audit/audit-service'
import { IGetOrderAuditTimelinePayload, IOrderAuditTimeline } from '../../Services/api/audit/audit.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class GetOrderAuditTimelineUseCase
implements IFormUsecase<IGetOrderAuditTimelinePayload, IOrderAuditTimeline> {
  constructor(private readonly auditApi: AuditApiRemoteService) {}

  public async handle(
    payload: IGetOrderAuditTimelinePayload,
  ): Promise<Result<IOrderAuditTimeline>> {
    try {
      return await this.auditApi.getOrderTimeline(payload)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
